import { z } from 'zod';

// Schema per le coordinate
const CoordinatesSchema = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180)
});

// Schema per gli items
const ItemSchema = z.object({
  name: z.string().min(1, 'Il nome dell\'articolo è obbligatorio').max(100, 'Il nome non può superare i 100 caratteri'),
  categoryId: z.string().min(1, 'La categoria è obbligatoria'),
  externalLink: z.string().optional(),
  categoryLabel: z.string().optional()
});

// Schema principale per la creazione di un indirizzo utente (GearPal senza items obbligatori)
// Items è opzionale quando si crea, ma se presente deve essere valido
// I contacts vengono gestiti dal profilo, non sono necessari qui
export const CreateUserAddressFormSchema = z.object({
  name: z.string().min(2, 'Il nome è obbligatorio').max(100, 'Il nome non può superare i 100 caratteri'),
  zipcode: z.string().regex(/^[0-9]{5}$/, 'Il codice postale deve essere di 5 cifre'),
  city: z.string().min(1, 'La città è obbligatoria').max(100, 'La città non può superare i 100 caratteri'),
  region: z.string().min(1, 'La regione è obbligatoria').max(100, 'La regione non può superare i 100 caratteri'),
  country: z.string().min(1, 'Il paese è obbligatorio').max(100, 'Il paese non può superare i 100 caratteri'),
  coordinates: CoordinatesSchema,
  // Items è opzionale - può essere vuoto quando si crea un indirizzo
  // Ma se presente, ogni item deve essere valido
  items: z.array(ItemSchema).optional().default([])
});

// Tipo TypeScript derivato dallo schema
export type CreateUserAddressFormData = z.infer<typeof CreateUserAddressFormSchema>;

